import { createValidation } from '../../utils/validation';
import trainingAssignmentConfig from './trainingAssignmentConfig';

// Create validation factory for TrainingAssignment entity
const createTrainingAssignmentValidation = () => {
  return createValidation(trainingAssignmentConfig.fields);
};

// Export both the factory and a default instance
export const validateTrainingAssignmentData = createTrainingAssignmentValidation();
export const createTrainingAssignmentValidationSchema = createTrainingAssignmentValidation;
export default createTrainingAssignmentValidation;
